// actions.js

import { actionTypes } from './actionTypes';
import { PowerBIRefreshWebSocketService } from '../../service/apis/powerBI.api';

const websocketMessageReceived =
  (buttonList, message, type) => async (dispatch) => {
    dispatch({
      type: actionTypes.powerBIRefresh.WEBSOCKET_MESSAGE_RECEIVED,
      payload: { buttonList, message, type },
    });
  };

const triggerButton = (code) => async (dispatch) => {
  //   dispatch({
  //     type: actionTypes.powerBIRefresh.TRIGGER_BUTTON_REQUEST,
  //     payload: {},
  //   });
  // console.log('PBI store data code check', code);
  try {
    await PowerBIRefreshWebSocketService.triggerButton();
    dispatch({
      type: actionTypes.powerBIRefresh.TRIGGER_BUTTON_SUCCESS,
      payload: code,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.powerBIRefresh.TRIGGER_BUTTON_FAILURE,
      payload: error,
    });
  }
};

const clearPBIrefreshData = () => async (dispatch) => {
  // console.log('refreshFlagData trigger');
  dispatch({
    type: actionTypes.powerBIRefresh.STATE_RESET,
    payload: {},
  });
};

export default {
  websocketMessageReceived,
  triggerButton,
  clearPBIrefreshData,
};
